/**
 * Two small "gate" cards rendered before the playback UI is available:
 *
 *   - <SpotifyNotConnected> — shown when the user has never linked Spotify.
 *   - <SpotifyPremiumGate>  — shown when linked but on a free Spotify plan;
 *     Spotify Web Playback SDK requires Premium for in-app streaming.
 */
import React from "react";
import { Crown } from "lucide-react";

export function SpotifyNotConnected({ onConnect }) {
  return (
    <div
      className="rounded-2xl bg-white/5 backdrop-blur-xl border border-white/10 p-4 flex items-center gap-4"
      data-testid="spotify-not-connected"
    >
      <div className="flex-1">
        <div className="font-bold mb-1">Connect Spotify</div>
        <p className="text-xs text-white/50">Link your account to play music while you train.</p>
      </div>
      <button
        onClick={onConnect}
        className="rounded-full bg-[#1DB954] hover:bg-[#1ed760] text-black font-bold uppercase tracking-wider text-xs px-5 py-2 transition-colors"
        data-testid="spotify-connect-btn"
      >
        Connect
      </button>
    </div>
  );
}

export function SpotifyPremiumGate() {
  return (
    <div
      className="rounded-2xl bg-[#FFB020]/10 backdrop-blur-xl border border-[#FFB020]/30 p-4"
      data-testid="spotify-premium-required"
    >
      <div className="flex items-center gap-2 mb-2">
        <Crown className="w-4 h-4 text-[#FFB020]" />
        <span className="font-bold text-[#FFB020] text-sm">Spotify Premium required</span>
      </div>
      <p className="text-xs text-white/60 mb-3">
        The in-app DAIONE player streams full tracks directly in your browser — that needs a Premium
        account. You can still browse your library below.
      </p>
      <a
        href="https://www.spotify.com/premium/"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block rounded-full bg-[#FFB020] hover:bg-[#ffc347] text-black font-bold uppercase tracking-wider text-xs px-5 py-2 transition-colors"
      >
        Upgrade Spotify
      </a>
    </div>
  );
}
